import { useAuthUser } from "~~/app/composables/useAuthUser";
import { isAdminUser } from "~/utils/permissions";

export const useAdmin = () => {
  const authUser = useAuthUser();

  return computed(() => isAdminUser(authUser.value));
};
